/* Copyright 2020 cpke
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by cpke <cryptio@pm.me>, December 2020
 */

import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Nav, NavItem, Navbar } from "react-bootstrap";
import "./App.css";
import Routes from "./Routes";
import jwt from "jwt-decode";
import { AppContext } from "./libs/contextLib";

export default function App(props) {
  const [isAuthenticated, userHasAuthenticated] = useState(false);

  const history = useHistory();

  const token = JSON.parse(localStorage.getItem("token"));

  let isAdmin = false;

  if (!token) {
    if (isAuthenticated) {
      userHasAuthenticated(false);
    }
  } else {
    if (token.token_expiry <= Math.ceil(Date.now() / 1000)) {
      handleLogout();
    } else {
      // Only update this value if not already set to true in order to prevent an infinite rendering loop
      if (!isAuthenticated) {
        userHasAuthenticated(true);
      }

      // const tokenDetails = jwt(jTok.access_token);
      isAdmin = true;
    }
  }

  function clearSession() {
    localStorage.clear();

    userHasAuthenticated(false);
  }

  function handleLogout() {
    clearSession();

    history.push("/login");
  }

  return (
    <div className="App container">
      <Navbar bg="light" expand="lg">
        <Navbar.Brand as={Link} to="/">
          Leet-Auth
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse>
          <Nav className="ml-auto">
            {isAdmin && (
              <React.Fragment>
                <NavItem href="/dashboard/apps">
                  <Nav.Link as={Link} to="/dashboard/apps">
                    Apps
                  </Nav.Link>
                </NavItem>
                <NavItem href="/dashboard/keys">
                  <Nav.Link as={Link} to="/dashboard/keys">
                    Keys
                  </Nav.Link>
                </NavItem>
                <NavItem href="/dashboard/files">
                  <Nav.Link as={Link} to="/dashboard/files">
                    Files
                  </Nav.Link>
                </NavItem>
                <NavItem href="/dashboard/licenses">
                  <Nav.Link as={Link} to="/dashboard/licenses">
                    Licenses
                  </Nav.Link>
                </NavItem>
                <NavItem href="/dashboard/variables">
                  <Nav.Link as={Link} to="/dashboard/variables">
                    Variables
                  </Nav.Link>
                </NavItem>
                <NavItem href="/dashboard/users">
                  <Nav.Link as={Link} to="/dashboard/users">
                    Users
                  </Nav.Link>
                </NavItem>
              </React.Fragment>
            )}
            {isAuthenticated ? (
              <React.Fragment>
                <NavItem onClick={handleLogout}>
                  <Nav.Link as={Link} to="">
                    Logout
                  </Nav.Link>
                </NavItem>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <NavItem href="/login">
                  <Nav.Link as={Link} to="/login">
                    Login
                  </Nav.Link>
                </NavItem>

                <NavItem href="/register">
                  <Nav.Link as={Link} to="/register">
                    Register
                  </Nav.Link>
                </NavItem>

                <NavItem href="/renew">
                  <Nav.Link as={Link} to="/renew">
                    Renew
                  </Nav.Link>
                </NavItem>
              </React.Fragment>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <AppContext.Provider value={{ isAuthenticated, userHasAuthenticated }}>
        <Routes />
      </AppContext.Provider>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/App.js